import { __assign } from "tslib";
import _ from 'lodash';
export var findMatchingTemplate = function (charge, templates) {
    return _.first(_.compact(_.map(templates, function (template, templateId) {
        var result = matchTemplate(charge, template);
        return result.success
            ? { type: templateId, params: result.params }
            : null;
    })));
};
export var matchTemplate = function (charge, template) {
    if (typeof charge !== typeof template) {
        return { success: false, params: {} };
    }
    var params = {};
    var success = true;
    _.each(template, function (v, k) {
        if (_.isString(v) && v.indexOf('%{') === 0) {
            params[v.slice(2, -1)] = charge[k];
        }
        else if (_.isArray(v) || _.isObject(v)) {
            var ret = matchTemplate(charge[k], v);
            success = success && ret.success;
            params = __assign(__assign({}, params), ret.params);
        }
        else {
            success = success && charge[k] === v;
        }
    });
    return { params: params, success: success };
};
export var fillTemplate = function (_a) {
    var template = _a.template, params = _a.params;
    var parse = function (v) {
        if (_.isString(v) && v.indexOf('%{') === 0) {
            return params[v.slice(2, -1)];
        }
        else if (_.isArray(v) || _.isObject(v)) {
            return fillTemplate({ template: v, params: params });
        }
        else {
            return v;
        }
    };
    if (_.isArray(template)) {
        return _.map(template, parse);
    }
    else {
        var ret_1 = {};
        _.each(template, function (v, k) {
            ret_1[k] = parse(v);
        });
        return ret_1;
    }
};
//# sourceMappingURL=JsonTemplates.js.map